import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-field-type-number",
  "use": "icon-field-type-number-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-field-type-number\">\n  <path d=\"M6.66797 2.66846L4.66797 13.3351M11.3346 2.66846L9.33463 13.3351M3.33464 5.33512H13.3346M2.66797 10.6685H12.668\" stroke=\"currentColor\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol